import { render, staticRenderFns } from "./Proofs.vue?vue&type=template&id=67d08e57&scoped=true"
import script from "./Proofs.vue?vue&type=script&lang=ts"
export * from "./Proofs.vue?vue&type=script&lang=ts"
import style0 from "./Proofs.vue?vue&type=style&index=0&id=67d08e57&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d08e57",
  null
  
)

export default component.exports